import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight, Home, Shield, Sun } from "lucide-react";
import { Link } from "react-router-dom";
import CTAButton from "./CTAButton";

const services = [
  {
    icon: Home,
    title: "Infissi & Serramenti",
    description: "Soluzioni su misura per comfort, isolamento e finiture curate. Finestre, porte interne e blindate, persiane e avvolgibili. Zanzariere integrate per protezione e praticità.",
    link: "/infissi",
  },
  {
    icon: Sun,
    title: "Outdoor & Soluzioni Ombra",
    description: "Più spazio da vivere all'aperto, tutto l'anno. Tende da sole, pergole bioclimatiche, tettoie e gazebi su misura. Arredi esterni coordinati per un risultato completo.",
    link: "/outdoor",
  },
  {
    icon: Shield,
    title: "Ferro & Sicurezza",
    description: "Carpenteria su misura per protezione e accessi. Grate, cancelli, ringhiere, balconi e scale: robustezza, precisione e design pulito, pensati per durare.",
    link: "/ferro",
  },
];

const ServicesSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="services" ref={ref} className="section-light py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="flex items-center justify-between mb-16"
        >
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-section-light-foreground uppercase tracking-wider">
            I nostri lavori
          </h2>
        </motion.div>

        <div className="space-y-4">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: i * 0.15 }}
            >
              <Link
                to={service.link}
                className="group flex items-start gap-6 p-6 md:p-8 border-b border-section-light-foreground/10 cursor-pointer transition-all duration-500 hover:bg-section-light-foreground/[0.03]"
              >
                <service.icon
                  size={28}
                  className="text-section-light-foreground/30 group-hover:text-accent transition-colors duration-500 mt-1 flex-shrink-0"
                />
                <div className="flex-1">
                  <h3 className="font-heading text-xl md:text-2xl font-semibold text-section-light-foreground uppercase tracking-wide">
                    {service.title}
                  </h3>
                  <p className="mt-2 text-section-light-foreground/50 font-body text-sm md:text-base max-w-lg">
                    {service.description}
                  </p>
                </div>
                <ArrowRight
                  size={20}
                  className="text-section-light-foreground/20 group-hover:text-accent group-hover:translate-x-2 transition-all duration-500 mt-2 flex-shrink-0"
                />
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.9 }}
          className="mt-6 text-xs text-section-light-foreground/40 font-body"
        >
          Agevolazioni e percentuali dipendono dalla normativa in vigore e dai requisiti dell'immobile/cliente.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-12"
        >
          <CTAButton className="cta-button-light hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300" />
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;